var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Temperatur",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Temperatur .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #Temperatur .cls-2 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2688",
    "data-name": "Pfad 2688",
    className: "cls-1",
    d: "M20,2.5A17.5,17.5,0,1,1,2.5,20,17.5,17.5,0,0,1,20,2.5M20,0a19.978,19.978,0,1,0,.044,0H20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2457",
    "data-name": "Rechteck 2457",
    className: "cls-2",
    width: 4.039,
    height: 1,
    transform: "translate(11.465 8.296)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2458",
    "data-name": "Rechteck 2458",
    className: "cls-2",
    width: 4.039,
    height: 1,
    transform: "translate(11.465 11.077)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2459",
    "data-name": "Rechteck 2459",
    className: "cls-2",
    width: 4.039,
    height: 1,
    transform: "translate(11.465 13.858)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2460",
    "data-name": "Rechteck 2460",
    className: "cls-2",
    width: 4.039,
    height: 1,
    transform: "translate(11.465 16.639)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2461",
    "data-name": "Rechteck 2461",
    className: "cls-2",
    width: 4.039,
    height: 1,
    transform: "translate(11.465 19.421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2689",
    "data-name": "Pfad 2689",
    className: "cls-2",
    d: "M23.093,24.2V5.324H16.64V24.2a5.493,5.493,0,0,0-2.324,4.5,5.55,5.55,0,1,0,11.1,0,5.493,5.493,0,0,0-2.324-4.5m-1.5-9.9H18.14V6.824h3.453Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.37649b66bc3e3fb9f1cf0678e79b464d.svg";
export { ForwardRef as ReactComponent };